package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Eswatini Flag (20x15dp)
 *
 * - ISO Alpha-2: SZ
 * - ISO Alpha-3: SWZ
 * - ISO Numeric: 748
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Eswatini: ImageVector by lazy {
    ImageVector.Builder(
        name = "Eswatini:SZ:SWZ:748:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                stroke = SolidColor(Color(0xFFFFD018)),
                strokeLineWidth = 1.25f
            ) {
                moveTo(0f, 3.125f)
                horizontalLineTo(-0.625f)
                verticalLineTo(3.75f)
                verticalLineTo(11.25f)
                verticalLineTo(11.875f)
                horizontalLineTo(0f)
                horizontalLineTo(20f)
                horizontalLineTo(20.625f)
                verticalLineTo(11.25f)
                verticalLineTo(3.75f)
                verticalLineTo(3.125f)
                horizontalLineTo(20f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(4.468f, 5.832f)
                curveTo(4.393f, 5.832f, 4.333f, 5.662f, 4.333f, 5.453f)
                curveTo(4.333f, 5.244f, 4.393f, 5.075f, 4.468f, 5.075f)
                horizontalLineTo(15.35f)
                curveTo(15.425f, 5.075f, 15.486f, 5.244f, 15.486f, 5.453f)
                curveTo(15.486f, 5.662f, 15.425f, 5.832f, 15.35f, 5.832f)
                horizontalLineTo(4.468f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.059f, 5.376f)
                lineTo(15.691f, 4.57f)
                lineTo(16.809f, 5.376f)
                lineTo(15.691f, 6.204f)
                lineTo(15.059f, 5.376f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(4.468f, 8.332f)
                curveTo(4.393f, 8.332f, 4.333f, 8.162f, 4.333f, 7.953f)
                curveTo(4.333f, 7.744f, 4.393f, 7.575f, 4.468f, 7.575f)
                horizontalLineTo(15.35f)
                curveTo(15.425f, 7.575f, 15.486f, 7.744f, 15.486f, 7.953f)
                curveTo(15.486f, 8.162f, 15.425f, 8.332f, 15.35f, 8.332f)
                horizontalLineTo(4.468f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.059f, 7.876f)
                lineTo(15.691f, 7.07f)
                lineTo(16.809f, 7.876f)
                lineTo(15.691f, 8.704f)
                lineTo(15.059f, 7.876f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(2.716f, 9.889f)
                curveTo(2.615f, 9.889f, 2.534f, 9.696f, 2.534f, 9.459f)
                curveTo(2.534f, 9.221f, 2.615f, 9.029f, 2.716f, 9.029f)
                horizontalLineTo(17.306f)
                curveTo(17.407f, 9.029f, 17.488f, 9.221f, 17.488f, 9.459f)
                curveTo(17.488f, 9.696f, 17.407f, 9.889f, 17.306f, 9.889f)
                horizontalLineTo(2.716f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.511f, 7.533f)
                curveTo(5.511f, 7.533f, 7.287f, 3.795f, 9.827f, 3.795f)
                curveTo(12.367f, 3.795f, 14.202f, 7.533f, 14.202f, 7.533f)
                curveTo(14.202f, 7.533f, 11.961f, 11.221f, 9.856f, 11.221f)
                curveTo(7.752f, 11.221f, 5.511f, 7.533f, 5.511f, 7.533f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(5.511f, 7.533f)
                curveTo(5.511f, 7.533f, 7.287f, 3.795f, 9.827f, 3.795f)
                curveTo(12.367f, 3.795f, 14.202f, 7.533f, 14.202f, 7.533f)
                curveTo(14.202f, 7.533f, 11.961f, 11.221f, 9.856f, 11.221f)
                curveTo(7.752f, 11.221f, 5.511f, 7.533f, 5.511f, 7.533f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.953f, 3.55f)
                curveTo(9.953f, 3.55f, 9.373f, 4.254f, 9.566f, 4.925f)
                curveTo(9.759f, 5.596f, 10.21f, 5.525f, 10.21f, 6.117f)
                curveTo(10.21f, 6.708f, 10.002f, 7.311f, 10.21f, 7.311f)
                curveTo(10.417f, 7.311f, 10.49f, 7.718f, 10.3f, 7.995f)
                curveTo(10.109f, 8.272f, 9.941f, 8.28f, 9.953f, 8.73f)
                curveTo(9.964f, 9.18f, 10.948f, 9.622f, 10.471f, 9.622f)
                curveTo(9.995f, 9.622f, 9.366f, 10.085f, 9.566f, 10.085f)
                curveTo(9.766f, 10.085f, 10.812f, 10.445f, 10.812f, 10.918f)
                curveTo(10.812f, 11.391f, 10.812f, 11.769f, 10.812f, 11.769f)
                horizontalLineTo(5.357f)
                verticalLineTo(3.55f)
                horizontalLineTo(9.953f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.387f, 6.202f)
                horizontalLineTo(7.115f)
                verticalLineTo(7.308f)
                horizontalLineTo(7.387f)
                verticalLineTo(6.202f)
                close()
                moveTo(8.188f, 6.202f)
                horizontalLineTo(7.916f)
                verticalLineTo(7.308f)
                horizontalLineTo(8.188f)
                verticalLineTo(6.202f)
                close()
                moveTo(7.516f, 6.202f)
                horizontalLineTo(7.787f)
                verticalLineTo(7.308f)
                horizontalLineTo(7.516f)
                verticalLineTo(6.202f)
                close()
                moveTo(8.588f, 6.202f)
                horizontalLineTo(8.317f)
                verticalLineTo(7.308f)
                horizontalLineTo(8.588f)
                verticalLineTo(6.202f)
                close()
                moveTo(8.717f, 6.202f)
                horizontalLineTo(8.989f)
                verticalLineTo(7.308f)
                horizontalLineTo(8.717f)
                verticalLineTo(6.202f)
                close()
                moveTo(9.389f, 6.202f)
                horizontalLineTo(9.118f)
                verticalLineTo(7.308f)
                horizontalLineTo(9.389f)
                verticalLineTo(6.202f)
                close()
                moveTo(7.115f, 7.788f)
                horizontalLineTo(7.387f)
                verticalLineTo(8.894f)
                horizontalLineTo(7.115f)
                verticalLineTo(7.788f)
                close()
                moveTo(8.188f, 7.788f)
                horizontalLineTo(7.916f)
                verticalLineTo(8.894f)
                horizontalLineTo(8.188f)
                verticalLineTo(7.788f)
                close()
                moveTo(7.516f, 7.788f)
                horizontalLineTo(7.787f)
                verticalLineTo(8.894f)
                horizontalLineTo(7.516f)
                verticalLineTo(7.788f)
                close()
                moveTo(8.588f, 7.788f)
                horizontalLineTo(8.317f)
                verticalLineTo(8.894f)
                horizontalLineTo(8.588f)
                verticalLineTo(7.788f)
                close()
                moveTo(8.717f, 7.788f)
                horizontalLineTo(8.989f)
                verticalLineTo(8.894f)
                horizontalLineTo(8.717f)
                verticalLineTo(7.788f)
                close()
                moveTo(9.389f, 7.788f)
                horizontalLineTo(9.118f)
                verticalLineTo(8.894f)
                horizontalLineTo(9.389f)
                verticalLineTo(7.788f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.611f, 6.202f)
                horizontalLineTo(10.339f)
                verticalLineTo(7.308f)
                horizontalLineTo(10.611f)
                verticalLineTo(6.202f)
                close()
                moveTo(11.412f, 6.202f)
                horizontalLineTo(11.14f)
                verticalLineTo(7.308f)
                horizontalLineTo(11.412f)
                verticalLineTo(6.202f)
                close()
                moveTo(10.74f, 6.202f)
                horizontalLineTo(11.011f)
                verticalLineTo(7.308f)
                horizontalLineTo(10.74f)
                verticalLineTo(6.202f)
                close()
                moveTo(11.812f, 6.202f)
                horizontalLineTo(11.541f)
                verticalLineTo(7.308f)
                horizontalLineTo(11.812f)
                verticalLineTo(6.202f)
                close()
                moveTo(11.941f, 6.202f)
                horizontalLineTo(12.213f)
                verticalLineTo(7.308f)
                horizontalLineTo(11.941f)
                verticalLineTo(6.202f)
                close()
                moveTo(12.613f, 6.202f)
                horizontalLineTo(12.342f)
                verticalLineTo(7.308f)
                horizontalLineTo(12.613f)
                verticalLineTo(6.202f)
                close()
                moveTo(10.339f, 7.788f)
                horizontalLineTo(10.611f)
                verticalLineTo(8.894f)
                horizontalLineTo(10.339f)
                verticalLineTo(7.788f)
                close()
                moveTo(11.412f, 7.788f)
                horizontalLineTo(11.14f)
                verticalLineTo(8.894f)
                horizontalLineTo(11.412f)
                verticalLineTo(7.788f)
                close()
                moveTo(10.74f, 7.788f)
                horizontalLineTo(11.011f)
                verticalLineTo(8.894f)
                horizontalLineTo(10.74f)
                verticalLineTo(7.788f)
                close()
                moveTo(11.812f, 7.788f)
                horizontalLineTo(11.541f)
                verticalLineTo(8.894f)
                horizontalLineTo(11.812f)
                verticalLineTo(7.788f)
                close()
                moveTo(11.941f, 7.788f)
                horizontalLineTo(12.213f)
                verticalLineTo(8.894f)
                horizontalLineTo(11.941f)
                verticalLineTo(7.788f)
                close()
                moveTo(12.613f, 7.788f)
                horizontalLineTo(12.342f)
                verticalLineTo(8.894f)
                horizontalLineTo(12.613f)
                verticalLineTo(7.788f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.27f, 4.42f)
                curveTo(7.889f, 4.538f, 7.715f, 5.535f, 7.758f, 5.776f)
                curveTo(7.8f, 6.017f, 7.929f, 5.746f, 7.929f, 5.746f)
                curveTo(7.929f, 5.746f, 8.193f, 6.318f, 8.22f, 6.472f)
                curveTo(8.247f, 6.626f, 8.385f, 6.239f, 8.385f, 6.239f)
                curveTo(8.385f, 6.239f, 8.842f, 6.553f, 8.904f, 6.904f)
                curveTo(8.965f, 7.254f, 9.058f, 6.503f, 9.058f, 6.503f)
                lineTo(9.162f, 6.485f)
                lineTo(9.096f, 6.114f)
                lineTo(9.294f, 6.282f)
                lineTo(9.233f, 5.937f)
                curveTo(9.233f, 5.937f, 9.381f, 6.131f, 9.344f, 5.918f)
                curveTo(9.306f, 5.704f, 9.285f, 5.585f, 9.285f, 5.585f)
                lineTo(9.233f, 5.293f)
                lineTo(9.429f, 5.258f)
                curveTo(9.429f, 5.258f, 8.65f, 4.302f, 8.27f, 4.42f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.305f, 8.56f)
            curveTo(15.91f, 8.61f, 15.566f, 9.562f, 15.566f, 9.807f)
            curveTo(15.566f, 10.052f, 15.74f, 9.807f, 15.74f, 9.807f)
            curveTo(15.74f, 9.807f, 15.9f, 10.416f, 15.9f, 10.572f)
            curveTo(15.9f, 10.728f, 16.103f, 10.372f, 16.103f, 10.372f)
            curveTo(16.103f, 10.372f, 16.498f, 10.761f, 16.498f, 11.116f)
            curveTo(16.498f, 11.472f, 16.72f, 10.748f, 16.72f, 10.748f)
            horizontalLineTo(16.825f)
            verticalLineTo(10.372f)
            lineTo(16.99f, 10.572f)
            verticalLineTo(10.222f)
            curveTo(16.99f, 10.222f, 17.103f, 10.439f, 17.103f, 10.222f)
            curveTo(17.103f, 10.005f, 17.103f, 9.884f, 17.103f, 9.884f)
            verticalLineTo(9.587f)
            horizontalLineTo(17.301f)
            curveTo(17.301f, 9.587f, 16.7f, 8.51f, 16.305f, 8.56f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.496f, 8.416f)
            curveTo(3.891f, 8.466f, 4.235f, 9.418f, 4.235f, 9.663f)
            curveTo(4.235f, 9.907f, 4.061f, 9.663f, 4.061f, 9.663f)
            curveTo(4.061f, 9.663f, 3.901f, 10.271f, 3.901f, 10.428f)
            curveTo(3.901f, 10.584f, 3.698f, 10.227f, 3.698f, 10.227f)
            curveTo(3.698f, 10.227f, 3.303f, 10.616f, 3.303f, 10.972f)
            curveTo(3.303f, 11.328f, 3.081f, 10.604f, 3.081f, 10.604f)
            horizontalLineTo(2.976f)
            verticalLineTo(10.227f)
            lineTo(2.811f, 10.428f)
            verticalLineTo(10.077f)
            curveTo(2.811f, 10.077f, 2.698f, 10.294f, 2.698f, 10.077f)
            curveTo(2.698f, 9.86f, 2.698f, 9.739f, 2.698f, 9.739f)
            verticalLineTo(9.443f)
            horizontalLineTo(2.5f)
            curveTo(2.5f, 9.443f, 3.101f, 8.366f, 3.496f, 8.416f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EswatiniPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Eswatini,
            contentDescription = "Eswatini Flag"
        )
    }
}
